/**
 * @desc export
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  zsnno: string,
  params: API.srm.supplierSn.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierSn/export/${zsnno}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
